import { createReducer } from "@reduxjs/toolkit";
import { ITemplateFolderState } from "./types";
import * as actions from "./actions";
import { StoreState } from "../storeState";
import { STORAGE_RESET } from "../storeReset";

const initialState = {
  data: [],
  state: StoreState.None,
} as ITemplateFolderState;

export const templateFolderReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(actions.templateFolderFetchRequest, (state) => ({
      ...state,
      state: StoreState.Loading,
    }))
    .addCase(actions.templateFolderFetchSuccess, (state, action) => ({
      ...state,
      state: StoreState.Loaded,
      data: action.payload,
    }))
    .addCase(actions.templateFolderFetchError, (state) => ({
      ...state,
      state: StoreState.Error,
    }))
    .addCase(STORAGE_RESET, () => initialState)
);
